import { api } from "../base";
import type { IBalanceReconResponse } from "@pulse-ui/codegen-v2/generated_ts/balance_recon";

export {
  BalanceReconCategory,
  BalanceReconDirection,
  BalanceShadowPath,
  BalanceShadowClass,
  type IBalanceReconResponse,
  type IBalanceReconCensus,
  type IBalanceReconFinding,
  type IBalanceShadowDisagreement,
} from "@pulse-ui/codegen-v2/generated_ts/balance_recon";

// Served by trading-ops-server GET /api/trading-ops/v1/balance-recon; Risk or Admin only.
const balanceReconEndpoints = api.injectEndpoints({
  endpoints: (build) => ({
    getBalanceRecon: build.query<IBalanceReconResponse, void>({
      query: () => ({
        url: "/api/trading-ops/v1/balance-recon",
      }),
    }),
  }),
});

export const { useGetBalanceReconQuery } = balanceReconEndpoints;
